





















































import { Watch } from "vue-property-decorator";
import WindowVue from "@/app/core/window/WindowVue";
import { Component, Mixins } from "vue-mixin-decorator";
import VueEvent from "@/app/core/decorator/VueEvent";
import {
  UserLoginInput,
  UserLoginWindowInput,
  UserType
} from "@/@types/socket";
import LanguageManager from "@/LanguageManager";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import { StoreUseData } from "@/@types/store";
import { UserData } from "@/@types/room";
import BaseInput from "@/app/core/component/BaseInput.vue";
import InputPasswordComponent from "@/app/core/component/InputPasswordComponent.vue";
import UserTypeSelect from "@/app/basic/common/components/select/UserTypeSelect.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";

@Component({
  components: {
    CtrlButton,
    UserTypeSelect,
    InputPasswordComponent,
    BaseInput
  }
})
export default class UserLoginWindow extends Mixins<
  WindowVue<UserLoginWindowInput, UserLoginInput>
>(WindowVue) {
  private name: string = "";
  private password: string = "";
  private type: UserType = "PL";
  private isMounted: boolean = false;
  private isSetting: boolean = false;
  private visitable: boolean = false;
  private userList: StoreUseData<UserData>[] | null = null;

  @LifeCycle
  public async created() {
    this.name = this.windowInfo.args!.name || "";
  }

  @LifeCycle
  public async mounted() {
    await this.init();
    this.inputEnter(".base-area select", this.commit);
    this.inputEnter(".base-area input:not([type='button'])", this.commit);
    this.isSetting = this.windowInfo.args!.isSetting;
    this.visitable = this.windowInfo.args!.visitable;
    this.userList = await SocketFacade.instance.userCC().getList(true);
    if (!this.isSetting) {
      this.windowInfo.heightEm = 9.5;
      this.windowInfo.declare.size.heightEm = 9.5;
      this.windowInfo.declare.minSize!.heightEm = 9.5;
      this.windowInfo.declare.maxSize!.heightEm = 9.5;
    }
    this.isMounted = true;
  }

  @Watch("isMounted")
  @Watch("name")
  private onChangeName() {
    if (!this.isMounted) return;
    const idx = this.userList!.findIndex(u => u.data!.name === this.name);
    if (idx >= 0) this.type = this.userList![idx]!.data!.type;
  }

  @Watch("currentDiceBotSystem")
  private onChangeCurrentDiceBotSystem(system: string) {
    window.console.log(system);
  }

  @VueEvent
  private async commit() {
    if (!this.name) return;
    await this.finally({
      name: this.name,
      type: this.type,
      password: this.password
    });
  }

  @VueEvent
  private async rollback() {
    await this.finally();
  }
}
